import { httpClient } from "../httpClient";

/**
 * POST /auth/login — no Bearer; 401 must not trigger global “session expired” handling.
 *
 * Expected 200 body (any one): `{ token }`, `{ accessToken }`, `{ access_token }`,
 * `{ data: { token } }`, `{ data: { accessToken } }`, `{ data: { access_token } }`.
 *
 * @param {{ email: string, password: string }} body
 */
export function postAdminLogin(body) {
  return httpClient.post("/auth/login", body, {
    skipAuth: true,
    skipUnauthorizedEvent: true,
  });
}
